import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Input, Form, FormText } from 'reactstrap';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../context';
// Note: Ensure BtxSwitch is imported from its corresponding file
import BtxSwitch from '../Forms/BtxSwitch';

const AttachmentSyncModal = (props) => {
    const { isOpen, closeModal, practiceId } = props;
    const dispatch = useDispatch();

    // Form state variables
    const [sourceFolder, setSourceFolder] = useState('');
    const [isRecursive, setIsRecursive] = useState(false);
    const [includedFiles, setIncludedFiles] = useState('');
    const [excludedFiles, setExcludedFiles] = useState('');
    const [message, setMessage] = useState('');    
    const [snapshotMode, setSnapshotMode] = useState('None');
    const [override, setOverride] = useState(false);

    // Handler for the toggle switch
    const handleSwitchChange = (newValue) => {
        setIsRecursive(!isRecursive);
    };

    const handleOverrideChange = (newValue) => {
        setOverride(!override);
    };

    // Submit form data to backend API via Redux action
    const submit = (e) => {
        e.preventDefault();

        if (!override) {
            // Use intermediate sync when override is false
            dispatch(actions.practice.triggerManualPracticeAttachmentSyncFromIntermediate(message, practiceId))
                .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
        } else {
            // Use sync endpoint with all parameters when override is true
            dispatch(actions.practice.triggerManualPracticeAttachmentSync(message, practiceId, sourceFolder, isRecursive, includedFiles, excludedFiles, snapshotMode))
                .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
        }

        resetForm();
        closeModalIntercept(closeModal);
    };

    // Reset all form fields
    const resetForm = () => {
        setMessage('');
        setSourceFolder('');
        setIsRecursive(false);
        setIncludedFiles('');
        setExcludedFiles('');
        setSnapshotMode('None');
        setOverride(false);
    };

    // Close modal with an intercept to also reset the form
    const closeModalIntercept = (closeModal) => {
        resetForm();
        closeModal();
    };

    return (
        <Modal isOpen={isOpen} centered className="text-light" toggle={() => closeModalIntercept(closeModal)} autoFocus={false}>
            <Form onSubmit={submit}>
                <ModalHeader>Attachments Sync</ModalHeader>
                <ModalBody>

                    {/* Reason input */}
                    <label className="mr-2 mb-0">Reason</label>
                    <Input 
                        autoFocus={true} 
                        value={message} 
                        onChange={e => setMessage(e.target.value)} 
                        type='textarea' 
                        placeholder={`Please include a reason for this Attachment Sync.`}>
                    </Input>
                    <FormText></FormText>

                    {/* Toggle Switch for Override */}
                    <div className="d-flex align-items-center my-3">
                        <label className="mr-2 mb-0">Override</label>
                        <div style={{ width: '80px' }}>
                            <BtxSwitch value={override} onChange={handleOverrideChange} />
                        </div>
                    </div>
                    <FormText></FormText>

                    {/* Hide if override is false */}
                    {override && (
                        <>
                            {/* Source Folder input */}
                            <label className="mr-2 mb-0">Source Folder</label>                    
                            <Input
                                type="text"
                                value={sourceFolder}
                                onChange={(e) => setSourceFolder(e.target.value)}
                                placeholder="Enter a complete source folder path."
                                className="mb-2"
                            />
                            <FormText></FormText>

                            {/* Toggle Switch for Recursive */}
                            <div className="d-flex align-items-center my-3">
                                <label className="mr-2 mb-0">Recursive</label>
                                <div style={{ width: '80px' }}>
                                    <BtxSwitch value={isRecursive} onChange={handleSwitchChange} />
                                </div>
                            </div>
                            <FormText></FormText>

                            {/* Included Files input */}
                            <label className="mr-2 mb-0">Included Files</label>                        
                            <Input
                                type="textarea"
                                value={includedFiles}
                                onChange={(e) => setIncludedFiles(e.target.value)}
                                placeholder="Enter filenames delimited by semi-colons."
                                className="mb-2"
                            />
                            <FormText></FormText>

                            {/* Excluded Files input */}
                            <label className="mr-2 mb-0">Excluded Files</label>                            
                            <Input
                                type="textarea"
                                value={excludedFiles}
                                onChange={(e) => setExcludedFiles(e.target.value)}
                                placeholder="Enter filenames delimited by semi-colons."
                                className="mb-2"
                            />
                            <FormText></FormText>

                            {/* Snapshot Mode dropdown */}
                            <label className="mr-2 mb-0">Snapshot Mode</label>                      
                            <Input
                                type="select"
                                value={snapshotMode}
                                onChange={(e) => setSnapshotMode(e.target.value)}
                                className="mb-2"
                            >
                                <option value="None">None</option>
                                <option value="VolumeShadowCopy">VolumeShadowCopy</option>
                                <option value="FileCopy">FileCopy</option>
                            </Input>
                            <FormText></FormText>
                        </>
                    )}

                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={resetForm}>Reset</Button>
                    <Button type="submit" color="success">Submit</Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default AttachmentSyncModal;
